type T = (response: Response) => Promise<Response>;

const f: T = async (response) => {
    if (response.ok) {
        return response;
    }

    throw { status: response.status, ...(await response.json()) };
};

export default f;
